var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "va-card",
                { staticClass: "pa-0" },
                [
                  _c("div", { staticClass: "border-b w-100" }, [
                    _c(
                      "h3",
                      { staticClass: "font-bold ma-4" },
                      [
                        _vm.icon
                          ? _c("v-icon", { staticClass: "mr-2" }, [
                              _vm._v(_vm._s(_vm.icon))
                            ])
                          : _vm._e(),
                        _vm._v(" " + _vm._s(_vm.title) + " ")
                      ],
                      1
                    )
                  ]),
                  _c(
                    "v-row",
                    { staticClass: "pa-0 ma-0" },
                    [
                      _vm.note1
                        ? _c(
                            "v-col",
                            {
                              class: [
                                "pa-4",
                                _vm.note2 ? "version-cell border-r" : ""
                              ],
                              attrs: { cols: "12", sm: _vm.note2 ? 6 : 12 }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-space-between flex-column flex-sm-row"
                                },
                                [
                                  _c("div", [
                                    _c("h4", { staticClass: "mb-2" }, [
                                      _vm._v(_vm._s(_vm.note1.title))
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("software.version")) +
                                          ": "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v(_vm._s(_vm.note1.version))]
                                      )
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "d-flex align-center" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("software.platform")
                                            ) +
                                            ": "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.note1.platformName)
                                            )
                                          ]
                                        ),
                                        _vm.note1.os === "android"
                                          ? _c("img", {
                                              staticClass: "ml-2",
                                              staticStyle: { width: "22px" },
                                              attrs: {
                                                src: require("@/assets/images/deviceTypes/android.svg"),
                                                alt: "android"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm.note1.os === "windows"
                                          ? _c("img", {
                                              staticClass: "ml-2",
                                              staticStyle: { width: "14px" },
                                              attrs: {
                                                src: require("@/assets/images/deviceTypes/microsoft.svg"),
                                                alt: "windows"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm.note1.os === "ios"
                                          ? _c("img", {
                                              staticClass: "ml-2",
                                              staticStyle: { width: "14px" },
                                              attrs: {
                                                src: require("@/assets/images/deviceTypes/apple.svg"),
                                                alt: "windows"
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column mt-4 mt-sm-0"
                                    },
                                    [
                                      _vm.note1.url
                                        ? _c("va-button", {
                                            staticClass: "mb-2",
                                            attrs: {
                                              icon: "vi vi-chevron-down",
                                              size: "s",
                                              cta: _vm.$t("common.download")
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.download(
                                                  _vm.note1.url
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _c("va-button", {
                                        staticClass: "mb-2",
                                        attrs: {
                                          type: "outline",
                                          size: "s",
                                          cta: _vm.$t("software.changelog")
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.showNotes(_vm.note1)
                                          }
                                        }
                                      }),
                                      _vm.note1.storeUrl &&
                                      _vm.storeBadge(_vm.note1.os)
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "version-store-badge mb-2",
                                              attrs: {
                                                href: _vm.note1.storeUrl,
                                                target: "_blank",
                                                rel: "noopener"
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticStyle: {
                                                  height: "36px",
                                                  width: "auto",
                                                  display: "block"
                                                },
                                                attrs: {
                                                  src: _vm.storeBadge(
                                                    _vm.note1.os
                                                  ),
                                                  alt: _vm.storeName(
                                                    _vm.note1.os
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.note2
                        ? _c(
                            "v-col",
                            {
                              staticClass: "pa-4",
                              attrs: { cols: "12", sm: _vm.note1 ? 6 : 12 }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-space-between flex-column flex-sm-row"
                                },
                                [
                                  _c("div", [
                                    _c("h4", { staticClass: "mb-2" }, [
                                      _vm._v(_vm._s(_vm.note2.title))
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("software.version")) +
                                          ": "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v(_vm._s(_vm.note2.version))]
                                      )
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "d-flex align-center" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("software.platform")
                                            ) +
                                            ": "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.note2.platformName)
                                            )
                                          ]
                                        ),
                                        _vm.note2.os === "android"
                                          ? _c("img", {
                                              staticClass: "ml-2",
                                              staticStyle: { width: "22px" },
                                              attrs: {
                                                src: require("@/assets/images/deviceTypes/android.svg"),
                                                alt: "android"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm.note2.os === "windows"
                                          ? _c("img", {
                                              staticClass: "ml-2",
                                              staticStyle: { width: "14px" },
                                              attrs: {
                                                src: require("@/assets/images/deviceTypes/microsoft.svg"),
                                                alt: "windows"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm.note2.os === "ios"
                                          ? _c("img", {
                                              staticClass: "ml-2",
                                              staticStyle: { width: "14px" },
                                              attrs: {
                                                src: require("@/assets/images/deviceTypes/apple.svg"),
                                                alt: "windows"
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column mt-4 mt-sm-0"
                                    },
                                    [
                                      _vm.note2.url
                                        ? _c("va-button", {
                                            staticClass: "mb-2",
                                            attrs: {
                                              icon: "vi vi-chevron-down",
                                              size: "s",
                                              cta: _vm.$t("common.download")
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.download(
                                                  _vm.note2.url
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _c("va-button", {
                                        staticClass: "mb-2",
                                        attrs: {
                                          type: "outline",
                                          size: "s",
                                          cta: _vm.$t("software.changelog")
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.showNotes(_vm.note2)
                                          }
                                        }
                                      }),
                                      _vm.note2.storeUrl &&
                                      _vm.storeBadge(_vm.note2.os)
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "version-store-badge mb-2",
                                              attrs: {
                                                href: _vm.note2.storeUrl,
                                                target: "_blank",
                                                rel: "noopener"
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticStyle: {
                                                  height: "36px",
                                                  width: "auto",
                                                  display: "block"
                                                },
                                                attrs: {
                                                  src: _vm.storeBadge(
                                                    _vm.note2.os
                                                  ),
                                                  alt: _vm.storeName(
                                                    _vm.note2.os
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      !_vm.note1 && !_vm.note2 && !_vm.$slots.default
                        ? _c(
                            "v-col",
                            { staticClass: "pa-4", attrs: { cols: "12" } },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("common.noData")) + " "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.$slots.default
                    ? _c(
                        "div",
                        {
                          class: [
                            "w-100",
                            _vm.note1 || _vm.note2 ? "border-t" : ""
                          ]
                        },
                        [_vm._t("default")],
                        2
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "content-class": "va-card va-dialog pa-0" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("div", { staticClass: "dialog-header border-b va-bg-base pa-4" }, [
            _c("h3", { staticClass: "mb-2" }, [_vm._v(_vm._s(_vm.title))]),
            _c("h4", [_vm._v(_vm._s(_vm.changelogTitle))])
          ]),
          _c("div", { staticClass: "dialog-content" }, [
            _c("div", {
              staticClass: "pa-4 changelog-body",
              domProps: { innerHTML: _vm._s(_vm.changelogText) }
            })
          ]),
          _c(
            "div",
            { staticClass: "dialog-footer pa-4 text-right border-t" },
            [
              _c("va-button", {
                attrs: { cta: _vm.$t("common.close") },
                on: {
                  click: function($event) {
                    _vm.dialog = false
                  }
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }